import { globalConstants } from "@/constants/globalConstants";

const LogoWrapper = ({ logo }) => {
  if (!logo) return null;
  const { desktop_image } = logo || {};
  const { IMAGES } = globalConstants?.olivegarden || {};
  return (
    <div className="logo-wrapper mr-auto mr-lg-0">
      <a href="/home"
        aria-label="Olive Garden logo"
        className="d-block trackContent"
        data-link-info="header|logo click"
      >
        <img
          className="ae-img-logo"
          title={desktop_image?.title}
          alt={desktop_image?.title}
          // src={desktop_image?.href}
          src={IMAGES?.LOGO_IMAGE.IMAGE_URL}
        />
      </a>
    </div>
  );
};

export default LogoWrapper;
